import { SlackService } from './../../services/slack.service';
import { WorkosService } from '../../services/workos.service';
import { Injectable } from '@angular/core';
import {ApiService} from '../../services/api.service';
import {HttpClient} from '@angular/common/http';
import {StorageService} from '../../services/storage.service';
import { switchMap, map, filter, take } from 'rxjs/operators';
import { BehaviorSubject, of, type Observable } from 'rxjs'

@Injectable({
  providedIn: 'root'
})

export class OrganisationService {
  public currentOrganisationSet$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor(
      private api: ApiService,
      private http: HttpClient,
      private storageService: StorageService,
      private workosService: WorkosService,
      private slackService: SlackService,
  ) { 
    const currentOrg = this.storageService.getCurrentOrganisation();
    this.currentOrganisationSet$.next(!!currentOrg);
  }

  public getOrganisations() {
    return this.api.getHeaders().pipe(
      switchMap(headers =>
        this.http.get(this.api.getHostVersion() + '/organisations', { headers })
      )
    );
  }

  public getCurrentOrganisation(): Observable<string> {
    return this.currentOrganisationSet$.pipe(
      filter(isSet => isSet),
      map(() => this.storageService.getCurrentOrganisation()),
      filter(org => !!org),
      take(1)
    );
  }

  public getCurrentProfile() {
    return this.getCurrentOrganisation().pipe(
      switchMap(organisationId => this.api.getHeaders().pipe(
        switchMap(headers =>
          this.http.get(this.api.getHostVersion() + '/organisation/' + organisationId + '/profile', { headers })
        )
      ))
    );
  }

  public async switchOrganisation(organisationId, workosOrganizationId="") {
    this.currentOrganisationSet$.next(false);

    if (workosOrganizationId) {
      try {
        await this.workosService.switchOrganization(workosOrganizationId);
      } catch (error) {
        const user = await this.workosService.getUser()
        await this.slackService.postError(error, `Error when switching to organization ${workosOrganizationId}`, user, 'medium')
      }

    }
    this.storageService.setCurrentOrganisation(organisationId);

    this.currentOrganisationSet$.next(true);
  }
}
